<template>
<div class="flex flex-wrap justify-center items-center">
  <a :href="links.facebook" target="_blank"><img src="~assets/img/facebook-circled.svg" alt="facebook"></a>
  <a :href="links.twitter" target="_blank"><img src="~assets/img/twitter-circled.svg" alt="twitter"></a>
  <span @click="copyURL" class="cursor-pointer inline-block text-3xl md:text-4xl material-icons">link</span>
</div>
</template>
<style lang="sass" scoped>
a, span
  @apply p-2
  img
    @apply w-6
    @screen md
      @apply w-8
</style>

<script>
export default {
  props: {
    article: {
      type: Object
    }
  },
  computed: {
    links() {
      const shareText = this.article.title;
      const shareURL = `${window.location.origin}${this.$route.path}`;
      return {
        absolute: shareURL,
        facebook: `https://www.facebook.com/share.php?u=${encodeURIComponent(shareURL)}`,
        twitter : `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareURL)}&text=${encodeURIComponent(shareText)}`
      }
    }
  },
  methods: {
    copyURL() {
      const { absolute } = this.links;
      const element = document.createElement('input');
      element.value = absolute;
      document.body.appendChild(element);
      element.select();
      document.execCommand('copy');
      document.body.removeChild(element);
    }
  }
}
</script>
